import React, {useEffect, useState} from 'react';
import ProgressIndicator from '../../assets/icons/progress-indicator.png';
import {getQueryElement} from '../../utils/queryElement';

function Spinner({customerData}) {
  const [rotation, setRotation] = useState(0);
  useEffect(() => {
    const elem = getQueryElement(customerData).querySelector('.preqaul--web--rotating-spinner');

    setTimeout(() => {
      elem.style.transform = `rotate(${rotation}deg)`;
      setRotation(rotation >= 360 ? 0 : rotation + 30);
    }, 120);
  }, [rotation]);
  return (
    <>
      <img width='88px' className='preqaul--web--rotating-spinner' src={ProgressIndicator} alt='loading..' />
    </>
  );
}

export default Spinner;
